import Base from "@/api/Base";

export default class Save extends Base
{
	setJobId (v)
	{
		this.jobId = v;
		return this;
	}

	getMethod ()
	{
		return this.jobId ? 'PUT' : 'POST';
	}

	getUrl ()
	{
		return this.jobId
			? '/job/' + this.jobId
			: '/job';
	}
}